export default __webpack_public_path__ + "static/media/kulies_logo.5bb8221f.png";